module.exports = __webpack_public_path__ + "img/arrow-right.34d5575d.svg";